import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Acccordion, Header, NavAndTabs, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { PiClockUserLight } from "react-icons/pi";
import DefaultWorkingTime from "../mySchedule/defaultWorkingTime";
import CustomWorkingTime from "../mySchedule/customWorkingTime";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../../contexts";

const ClinicSchedule = ({ loginData }) => {
    const { t } = useTranslation();
    const { showAlert } = useAlert();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actionDoctor.getClinicDetailsByDoctorId(loginData.userGuid));
    }, [dispatch, loginData]);

    const getClinicDetailsByDoctorIdData = useSelector(
        (state) => state.doctor.getClinicDetailsByDoctorIdData?.data
    );
    const getClinicDoctorServiceAndScheduleData = useSelector(
        (state) => state.doctor.getClinicDoctorServiceAndScheduleData?.data
    );

    let onlineAppointments = [];
    let offlineAppointments = [];
    let customAppointments = [];

    if (typeof getClinicDoctorServiceAndScheduleData !== "undefined") {
        const { defaultTiming, customTiming } =
            getClinicDoctorServiceAndScheduleData.result;

        onlineAppointments =
            defaultTiming?.filter((item) => item.isOnlineAppointment) || [];
        offlineAppointments =
            defaultTiming?.filter((item) => !item.isOnlineAppointment) || [];
        customAppointments = customTiming || [];
    }

    const [activeTab, setActiveTab] = useState("default-working-time");
    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        // navigate(`/doctor/my-schedule/${tabId}`);
    };
    const tabs = [
        {
            id: "default-working-time",
            label: t("visiting_schedule.default_working_time"),
            content: (
                <DefaultWorkingTime
                    onlineAppointments={onlineAppointments}
                    offlineAppointments={offlineAppointments}
                    hiddenColumns={[`${t("Edit")}`, `${t("delete")}`]}
                />
            ),
        },
        {
            id: "custom-working-time",
            label: t("visiting_schedule.custom_working_time"),
            content: (
                <CustomWorkingTime
                    customAppointments={customAppointments}
                    hiddenColumns={[`${t("Edit")}`, `${t("delete")}`]}
                />
            ),
        },
    ];
    const items = getClinicDetailsByDoctorIdData?.result?.clinicServices?.map(
        (service) => ({
            serviceId: service.clinicGuid,
            icon: <PiClockUserLight className="acc-icon" />,
            title: `${service.serviceName} from ${service.clinicName} `,
            content: (
                <NavAndTabs.NavAndTabs
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={onTabChange}
                />
            ),
        })
    );

    const handleItemClick = (item) => {
        dispatch(actionDoctor.clearClinicDoctorServiceAndScheduleData());
        dispatch(
            actionDoctor.getClinicDoctorServiceAndSchedule(
                loginData.userGuid,
                item.serviceId,
                (error) => {
                    if (error) {
                        if (error.data && error.status === 500) {
                            console.log("error", error.data.error.ErrorMessage);
                            showAlert(
                                "danger",
                                error.data.error.ErrorMessage,
                                `${t("Error")}`
                            );
                        }
                    }
                }
            )
        );
    };
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={t("Clinic_Schedule")}
                    // buttons={buttons}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <Acccordion.Acccordion
                        items={items}
                        alwaysOpen={false}
                        className="acccordian acccordian1"
                        Open={<FaCaretUp className="acc-icn" />}
                        Close={<FaCaretDown className="acc-icn" />}
                        onClick={handleItemClick}
                    />
                    {/* <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    /> */}
                </Col>
            </Row>
        </Container>
    );
    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
        </>
    );
};

export default ClinicSchedule;
